module.exports = __webpack_public_path__ + "img/Intranet_Head2_2.2fef46e2.png";